import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getPlans } from '../../services/plans-service'

const initialState = {
  plans: [],
  totalPlansCount: 0,
  isFetchingPlans: false,
}

export const fetchPlansAction = createAsyncThunk(
  'plans/fetchPlans',
  async () => {
    return await getPlans()
  },
)

const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchPlansAction.pending, state => {
        state.isFetchingPlans = true
      })
      .addCase(fetchPlansAction.fulfilled, (state, action) => {
        state.plans = action.payload.data.plans
        state.totalPlansCount = action.payload.data.count
        state.isFetchingPlans = false
      })
      .addCase(fetchPlansAction.rejected, state => {
        state.isFetchingPlans = false
      })
  },
})

export default plansSlice.reducer
